// aiUrl路径
export default {
  // baseUrl: 'http://dev.gzmoninet.com/moni-web', // 测试服务器
  // baseAppPath: 'http://dev.gzmoninet.com/app-yunejia',
  baseUrl: 'https://api.gzmoninet.com/moni-web', // 正式服务器
  baseAppPath: 'https://api.gzmoninet.com/app-yunejia', // 正式服务器

  banner: '/banner/record/6',

  newsRecord: '/news/record/3',
  newsDetail: '/news/detail/',
  newsListInfo: '/news/list/',

  recruitListInfo: '/recruitment/list/',
  recruitDetail: '/recruitment/detail/',

  leaveMsg: '/content/save/',

  deviceSwitch: '/supplier/device/switch',

  // 查询商品协议列表接口
  announcementList: '/api/common/announcement/list',
  announcementInfo: '/api/common/announcement/details',

  globalData: {
    isAutoPlay: true
  }

}


// WEBPACK FOOTER //
// ./src/api/apiUrl.js